module.exports = __webpack_public_path__ + "img/brain.2855dc5a.svg";